
























import { Component, Vue } from 'vue-property-decorator'
import { ITuileNav } from '@/models/ui/ITuileNav'


@Component({
  name:"SectionTuileDouble",
  components: {    
  },
  props:{    
    items:Array
  }
})
export default class SectionTuileDouble extends Vue {    
  items!:Array<ITuileNav>  
}
